import type { StylingConfigurationUrls } from '@ad-lucy/services/LiveRendering';
import { AssetsUtils } from '../assets';
import { HttpService, ResponseType } from '../http';
import { getModuleLogger } from '../logger/Logger';

const logger = getModuleLogger('mountPublicCSS');

const mountScript = (src: string, id?: string): void => {
  const scriptElement = document.createElement('script');
  scriptElement.src = src;
  scriptElement.id = id ?? src;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  if (firstScriptTag) {
    firstScriptTag.parentNode?.insertBefore(scriptElement, firstScriptTag);
  } else {
    document.body.prepend(scriptElement);
  }
};

const mountPublicCSS = (filePath: string, id?: string): Promise<void> =>
  HttpService.get<string>(filePath, {
    responseType: ResponseType.TEXT,
  })
    .then((data: string | undefined): void => {
      if (data) {
        const ref = document.querySelector('script');
        const styleElement = document.createElement('style');
        styleElement.id = id ?? filePath;
        styleElement.innerHTML = data;
        ref?.parentNode?.insertBefore(styleElement, ref);
      }
    })
    .catch((e) => logger.error(`Can't mount ${filePath}`, e));

const mountPublicCSSFiles = (paths?: StylingConfigurationUrls): Promise<unknown[]> =>
  Promise.all([
    mountPublicCSS(
      paths?.themeUrl ?? `./${AssetsUtils.getAssetsCSSFilePath('theme.css')}`,
      'theme-styles',
    ),
    mountPublicCSS(
      paths?.fontsUrl ?? `./${AssetsUtils.getAssetsCSSFilePath('fonts.css')}`,
      'font-styles',
    ),
    mountPublicCSS(
      paths?.customCssUrl ?? `./${AssetsUtils.getAssetsCSSFilePath('custom.css')}`,
      'custom-styles',
    ),
  ]);

export const BootstrapUtils = {
  mountPublicCSSFiles,
  mountScript,
};
